import { makeVar, InMemoryCache, type ReactiveVar } from '@apollo/client';

import type { Brand } from 'src/App/generated/graphql-types';
import type { Toast } from 'src/types';

// File object that is stored temporarily
// until the cover crop has finished
export const selectedFileVar: ReactiveVar<File | null> = makeVar<File | null>(
  null,
);

// Variable to track loading state of cover/logo image upload
export const isCoverSavingVar: ReactiveVar<boolean> = makeVar<boolean>(false);
export const isLogoSavingVar: ReactiveVar<boolean> = makeVar<boolean>(false);

type BrandState = Partial<Brand>;
export const brandStateVar: ReactiveVar<BrandState> = makeVar<BrandState>({});
export const originalBrandStateVar: ReactiveVar<BrandState> =
  makeVar<BrandState>({});

export const toastQueueVar: ReactiveVar<Toast[]> = makeVar<Toast[]>([]);
export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        toastQueue: {
          read() {
            return toastQueueVar();
          },
        },
        isCoverSaving: {
          read() {
            return isCoverSavingVar();
          },
        },
        isLogoSaving: {
          read() {
            return isLogoSavingVar();
          },
        },
        selectedFile: {
          read() {
            return selectedFileVar();
          },
        },
        brandState: {
          read() {
            return brandStateVar();
          },
        },
        originalBrandState: {
          read() {
            return originalBrandStateVar();
          },
        },
      },
    },
  },
});
